// extracted by mini-css-extract-plugin
export default {"name":"RacetimeName_name__cQMkl","discriminator":"RacetimeName_discriminator__M4JjF"};